const SvgSelectDown = () => {
  return (
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.69857L7.84831 8.54687L14.6966 1.69857"
        stroke="#00B8DB"
        strokeWidth="2.44928"
      />
    </svg>
  );
};

export default SvgSelectDown;
